import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'
import _ from 'lodash'
import { languageChange, queryConfigItem } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const FESTIVAL_GET_5_DIRHAM_EVERY_WEEK = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    RECEIVE_REQUEST: null,
    RECEIVE_SUCCESS: null,
    QUERY_RECEIVE_STATUS_REQUEST: null,
    QUERY_RECEIVE_STATUS_SUCCESS: null,
    REMOVE_TIPS_INFO: null
  },
  'FESTIVAL_GET_5_DIRHAM_EVERY_WEEK'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/activity/detail',
        method: 'POST',
        body: {
          scenesCode: 'OLD_COMMON_WEEKLY'
        },
        requestAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.INIT_REQUEST,
        successAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.INIT_SUCCESS,
        success: function(result) {
          const { bizData = {} } = result.commandData
          const { activityStatus, activityCode } = bizData
          if (activityStatus === 'N') {
            dispatch(queryConfigItem({ itemKey: 'MEMBER_SHARE' }))
          } else {
            activityCode && dispatch(queryReceiveStatus({ activityCode }))
          }
        }
      })
    )
  }
}

export function receive(data) {
  Toast.loading('', 0)
  // 老用户领取
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/voucher/get',
        method: 'POST',
        body: data,
        requestAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.RECEIVE_REQUEST,
        successAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.RECEIVE_SUCCESS,
        success: function(result) {
          Toast.hide()
        }
      })
    )
  }
}

export function queryReceiveStatus(data) { // 查询领取状态
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/voucher/receive-status',
        method: 'POST',
        body: data,
        requestAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.QUERY_RECEIVE_STATUS_REQUEST,
        successAction: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.QUERY_RECEIVE_STATUS_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

export function removeTipsInfo() {
  return (dispatch) => {
    dispatch({
      type: FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.REMOVE_TIPS_INFO
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.INIT_REQUEST]: (state, action) => state,
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.INIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, { ...commandData })
  },
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.RECEIVE_REQUEST]: (state, action) => state,
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.RECEIVE_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    if (_.get(commandData, 'bizData.amount')) {
      commandData.bizData.receiveStatus = 'Y' // 首次领取成功
    }
    state.bizData = Object.assign({}, state.bizData, commandData.bizData)
    return Object.assign({}, state, { tipsInfo: commandData.tipsInfo })
  },
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.QUERY_RECEIVE_STATUS_REQUEST]: (state, action) =>
    state,
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.QUERY_RECEIVE_STATUS_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    const vouchers = _.get(commandData.bizData, 'vouchers')
    let couponAmount = {}
    if (_.size(vouchers)) {
      couponAmount = vouchers[0]
    }
    state.bizData = Object.assign({}, state.bizData, commandData.bizData, couponAmount)
    return Object.assign({}, state, { tipsInfo: commandData.tipsInfo })
  },
  [FESTIVAL_GET_5_DIRHAM_EVERY_WEEK.REMOVE_TIPS_INFO]: (state, action) => {
    return Object.assign({}, state, { tipsInfo: {} })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'festivalGet5DirhamEveryWeek',
    reducerMap: {
      festivalGet5DirhamEveryWeekState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')],
    // finalActions: []
  }
}
